import { DetailsCard } from "components";
import { AdvisedCriticalHistoryTable } from "components/AdvisedCriticalHistory/components";

import type { SectionMenu } from "components";
import type { Appointment } from "models";

type AdvisedCriticalItemsHistoryProps = {
  isExpanded: boolean;
  sectionMenu: SectionMenu;
  carId?: number;
  appointment?: Appointment;
};

export const AdvisedCriticalHistory = ({ isExpanded, sectionMenu, appointment, carId }: AdvisedCriticalItemsHistoryProps) => {
  if (!sectionMenu.count || (!appointment && !carId)) return null;

  return (
    <>
      <DetailsCard sectionMenuId={sectionMenu.id} title={`${sectionMenu.title} (${sectionMenu.count})`} icon={sectionMenu.icon} isExpanded={isExpanded}>
        <AdvisedCriticalHistoryTable appointment={appointment} appointmentId={appointment?.id} carId={carId} />
      </DetailsCard>
    </>
  );
};
